import React, { useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useScrollToFormikError } from "hooks/useScrollToFormikError";

type RevertPakingProps = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const RevertPaking: React.FC<RevertPakingProps> = ({ show, setShow }) => {
  const handleClose = () => {
    setShow(false);
  };
  const formik = useFormik({
    initialValues: {
      // date: new Date().toISOString().split("T")[0],
      date: "",
      revert_by: "",
      reason: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      date: Yup.string().required("Date is required"),
      revert_by: Yup.string().required("Revert By is required"),
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: (values) => {
      handleClose();
    },
  });

  useScrollToFormikError(formik.errors, formik.submitCount);

  // useEffect(() => {
  //   if (row) {
  //     formik.setValues({
  //       date: new Date().toISOString().split("T")[0],
  //       revert_by: row.initiated_by || "",
  //       reason: "",
  //     });
  //   }
  // }, [row]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Form noValidate onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Revert Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-3">
            <Col md={4}>
              <Form.Label>
                Date
                {/* & Time */}
              </Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formik.values.date}
                onChange={(e) => {
                  formik.handleChange(e);
                  if ((e.target.value || "").trim()) setTimeout(() => formik.setFieldError("date", undefined), 0);
                }}
                onBlur={() => formik?.setFieldTouched("date", true)}
                isInvalid={!!formik.errors.date && formik.touched.date}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.date}
              </Form.Control.Feedback>
            </Col>
            <Col md={4}>
              <Form.Label>Revert By</Form.Label>
              <Form.Control
                type="text"
                name="revert_by"
                placeholder="Enter Name"
                value={formik.values.revert_by}
                onChange={(e) => {
                  formik.handleChange(e);
                  if ((e.target.value || "").trim()) setTimeout(() => formik.setFieldError("revert_by", undefined), 0);
                }}
                onBlur={() => formik?.setFieldTouched("revert_by", true)}
                isInvalid={
                  !!formik.errors.revert_by && formik.touched.revert_by
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.revert_by}
              </Form.Control.Feedback>
            </Col>
            <Col md={4}>
              <Form.Label>Reason for Revert</Form.Label>
              <Form.Control
                type="text"
                name="reason"
                placeholder="Enter Reason"
                value={formik.values.reason}
                onChange={(e) => {
                  formik.handleChange(e);
                  if ((e.target.value || "").trim()) setTimeout(() => formik.setFieldError("reason", undefined), 0);
                }}
                onBlur={() => formik?.setFieldTouched("reason", true)}
                isInvalid={!!formik.errors.reason && formik.touched.reason}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.reason}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center gap-2">
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RevertPaking;
